import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ConsumercreditComponent } from './consumercredit.component';
import { CreditCheckComponent } from './credit-check/credit-check.component';
import { DummyCheckComponent } from './dummy-check/dummy-check.component';
import { ManualReviewModule } from './manualreview/manual-review.module';
import { EspotComponent } from './espot/espot.component';
import { CustomerDetailModule } from './customer-detail/customer-detail.module';
import { PopupModule } from '../lib/shared/popup/popup.module';
import{SharedModule} from '../lib/shared/shared.module';

@NgModule({
  declarations: [ConsumercreditComponent,CreditCheckComponent,DummyCheckComponent,EspotComponent],
  imports: [
    CommonModule,BrowserModule,FormsModule,ReactiveFormsModule,PopupModule,CustomerDetailModule,ManualReviewModule,SharedModule
    
  ],
  exports: [ConsumercreditComponent]
})
export class ConsumercreditModule { }
